// Bounty Rankings — every known One Piece bounty, highest to lowest.

import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import animeConfig from '../config/animeConfig';
import characterProfiles from '../data/characterProfiles';
import './BountyRankings.css';

const RANKED = characterProfiles
  .map((c) => ({ ...c, bountyNum: Number(String(c.bounty || '').replace(/[^0-9]/g, '')) }))
  .filter((c) => c.bountyNum > 0)
  .sort((a, b) => b.bountyNum - a.bountyNum);

const medal = (i) => (i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : `#${i + 1}`);

const BountyRankings = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  const list = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return RANKED;
    return RANKED.filter(
      (c) => c.name.toLowerCase().includes(q) || (c.crew || '').toLowerCase().includes(q)
    );
  }, [query]);

  // The same sea the rest of the archive sits on, under a dark wash so the
  // cards and the text keep their contrast.
  const seaStyle = {
    backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.86)), url(${animeConfig.onePiece.backgroundImage})`,
  };

  return (
    <>
      <Helmet>
        <title>One Piece Bounty Rankings — Highest Bounties | One Piece Trivia</title>
        <meta name="description" content="Every known One Piece bounty ranked from highest to lowest, from Luffy and the Yonko down the line." />
        <link rel="canonical" href="https://www.onepiecetrivia.com/bounties" />
        <meta property="og:title" content="One Piece Bounty Rankings" />
        <meta property="og:description" content="Every known One Piece bounty ranked from highest to lowest, from Luffy and the Yonko down the line." />
        <meta property="og:url" content="https://www.onepiecetrivia.com/bounties" />
      </Helmet>

      <div className="br-container" style={seaStyle}>
        <h1 className="br-title">Bounty Rankings</h1>
        <p className="br-sub">Every known bounty in One Piece, highest to lowest.</p>

        <input
          className="br-search"
          type="text"
          placeholder="Search a pirate or crew..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />

        <div className="br-list">
          {list.map((c, i) => {
            const rank = query ? RANKED.indexOf(c) : i;
            return (
              <button
                key={c.slug || c.name}
                className={`br-row ${rank < 3 ? 'top' : ''}`}
                onClick={() => c.slug && navigate(`/characters/${c.slug}`)}
              >
                <span className="br-rank">{medal(rank)}</span>
                <img src={c.image} alt={c.name} className="br-img" loading="lazy" />
                <span className="br-name">
                  <span className="br-fullname">{c.name}</span>
                  {c.crew && <span className="br-crew">{c.crew}</span>}
                </span>
                <span className="br-bounty">฿{c.bountyNum.toLocaleString('en-US')}</span>
              </button>
            );
          })}
          {list.length === 0 && <p className="br-empty">No pirates match that search.</p>}
        </div>
      </div>
    </>
  );
};

export default BountyRankings;
